export default __webpack_public_path__ + "static/2-081df90c5476e23d56b659b515f88a37.webp";